import React from 'react';
import { Helmet } from 'react-helmet';
import metadata from '../../data/json/metadata.json';

export interface SEOProps {
  title?: string;
  index?: boolean;
  description?: string;
  lang?: string;
  meta?: HTMLMetaElement[];
}

const SEO: React.FC<SEOProps> = ({
  title,
  index,
  description,
  lang = 'en',
  meta = [],
}) => {
  if(index == true){
    var title_template = metadata.title;
  }else{
    var title_template = `${title} • ${metadata.title}`;
  }
  
  const metaDescription = description || metadata.description;

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title_template}
      meta={[
        {
          name: 'description',
          content: metaDescription,
        },
        {
          name: 'keywords',
          content: metadata.keywords,
        },
        {
          name: 'canonical',
          content: metadata.homepage,
        },
        {
          name: 'theme-color',
          content: metadata.themeColor,
        },
        {
          property: `og:title`,
          content: metadata.title,
        },
        {
          property: `og:description`,
          content: metadata.description,
        },
        {
          property: `og:type`,
          content: `website`,
        },
        {
          property: `og:url`,
          content: metadata.homepage,
        },
        {
          name: `twitter:card`,
          content: `summary`,
        },
        {
          name: `twitter:site`,
          content: metadata.homepage,
        },
        {
          name: `twitter:title`,
          content: metadata.title,
        },
        {
          name: `twitter:description`,
          content: metadata.description,
        },
        {
          name: `google-site-verification`,
          content: metadata.verification.google,
        },
      ].concat(meta)}
    />
  );
};

export default SEO;
